// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ParseIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ParseIcon" ref={forwardedRef} {...props}>
      <path d="M16 5.5a1 1 0 0 1-1 1h-4.25v3.129l1.725-1.725 1.06 1.06L10 12.5 6.464 8.964l1.061-1.06L9.25 9.629V6.5H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1zm-1.5-2h-9V5h9z" />
      <path d="M15 18a1 1 0 0 0 1-1v-2.5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1V17a1 1 0 0 0 1 1zm-9.5-3h3.75v1.5H5.5zm5.25 0h3.75v1.5h-3.75z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ParseIcon = /* @__PURE__ */ Object.assign(ParseIconComponent, {
  displayName: 'ParseIcon',
});
